import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import ActionButton from "../v2/common/ActionButton";

export default function Auth0LogoutButton (props){
  const logoutUser = () => {
    window.location.href = '/logout';
  };

  let label = props.label || "Logout";
  let view = props.isLink ?
    <Link className="font-14-fustat-semi-bold color-grey-dark" to='/logout' onClick={logoutUser}>{label}</Link> :
    <ActionButton label={label} action={logoutUser} withIcon={false} sx={{height: '45px'}} />

  return (
    <Fragment>
      {view}
    </Fragment>
  );
};